import {PortalDashboardContext} from "components/src/context/PortalDashboardContextProvider";
import {useContext} from 'react'

export function usePortalDashboardContext()
{
    const context = useContext(PortalDashboardContext);

    if (!context) {
        throw new Error(
            "usePortalDashboardContext must be used within the scope of PortalDashboardContextProvider"
        );
    }

    return context;
}
